import { useTranslation } from 'react-i18next';
import { WREG_TOTAL_STEPS } from './wregSteps';

type Props = {
  n: number | null;
  total?: number;
};

const WregPhase = ({ n, total = WREG_TOTAL_STEPS }: Props) => {
  const { t } = useTranslation();
  // A step missing from WREG_STEP_NUMBER renders nothing rather than a confident, wrong "Step 1
  // of 8". The table is a full Record over WregNumberedStep, so a dropped entry fails to compile;
  // this guard is for the exception steps, which are deliberately unnumbered.
  if (n === null) return null;
  const step = Math.min(total, Math.max(1, n));
  const label = t('wreg.phasebar', { n: step, total });
  return (
    <div
      className="rg-phasebar c-bar"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={step}
      aria-label={label}
    >
      <div className="rg-phasebar-step">{label}</div>
      <div className="c-bar-track">
        <div className="c-bar-fill" style={{ width: `${(step / total) * 100}%` }} />
      </div>
    </div>
  );
};

export { WregPhase };
